// Pre-search list-builder findings (spec section 7). Only meaningful before
// any results are shown — the caller (DataSearch.js) is responsible for not
// calling this once a search has results on screen.
const searchEmptyFindings = ({ hasSearched = false, hasProfile = false, savedLists = [], actions = {} } = {}) => {
  const out = [];
  const lists = Array.isArray(savedLists) ? savedLists : [];

  if (!hasSearched && !hasProfile) {
    out.push({
      tone: "hot",
      key: "first_no_profile",
      label: "Let's build your ICP",
      text: "Tell me your website and I will draft your ideal customer profile and seller intelligence.",
      actions: actions.buildIcp ? [{ label: "Let's build your ICP", run: actions.buildIcp }] : []
    });
  }

  if (!hasSearched && hasProfile) {
    out.push({
      tone: "hot",
      key: "first_has_profile",
      label: "Find contacts with my ICP",
      text: "Start from your seller profile, or describe who you want.",
      actions: [
        actions.useIcp && { label: "Find contacts with my ICP", run: actions.useIcp },
        actions.describe && { label: "Or describe who you're looking for", run: actions.describe }
      ].filter(Boolean)
    });
  }

  if (hasSearched && !lists.length) {
    out.push({
      tone: "neutral",
      key: "returning_no_saved",
      label: "Pick up where you left off",
      actions: [
        actions.rerun && { label: "Rerun my last search", run: actions.rerun },
        actions.useIcp && { label: "Start fresh with my ICP", run: actions.useIcp }
      ].filter(Boolean)
    });
  }

  if (lists.length) {
    const name = lists[0]?.name || lists[0]?.title || "your list";
    out.push({
      tone: "neutral",
      key: "returning_saved_lists",
      label: `Find new matches for ${name}`,
      actions: [
        actions.findSimilar && { label: "Find new matches", run: () => actions.findSimilar(name) },
        actions.describe && { label: "Build a different list", run: actions.describe }
      ].filter(Boolean)
    });
  }

  return out;
};

export default searchEmptyFindings;
